
interface Pet {
  id: number;
  name: string;
  category: string;
  breed: string;
  age: string;
  gender: string;
  price: number;
  location: string;
  description: string;
  image: string;
  seller: string;
  featured: boolean;
}

interface PetDetailModalProps {
  pet: Pet;
  onClose: () => void;
}

export default function PetDetailModal({ pet, onClose }: PetDetailModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative">
          <div className="w-full h-72 overflow-hidden rounded-t-3xl">
            <img
              src={pet.image}
              alt={`${pet.name} - ${pet.breed}`}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all cursor-pointer"
          >
            <i className="ri-close-line text-xl text-[#4A3B5C]"></i>
          </button>
          {pet.featured && (
            <div className="absolute top-4 left-4 bg-gradient-to-r from-[#F5A623] to-[#FF9BC8] text-white text-sm font-bold px-4 py-1.5 rounded-full shadow-md">
              <i className="ri-star-fill mr-1"></i>Featured
            </div>
          )}
        </div>

        <div className="p-8">
          <div className="mb-4">
            <h2 className="text-3xl font-bold text-[#4A3B5C]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              {pet.name}
            </h2>
            <p className="text-[#8B7BA8] font-medium mt-1">{pet.breed}</p>
          </div>

          <div className="grid grid-cols-3 gap-4 mb-6">
            <div className="bg-[#F8F6FB] rounded-xl p-4 text-center">
              <i className="ri-calendar-line text-[#9B4C9A] text-xl mb-1 block"></i>
              <p className="text-xs text-[#8B7BA8]">Age</p>
              <p className="text-sm font-bold text-[#4A3B5C]">{pet.age}</p>
            </div>
            <div className="bg-[#F8F6FB] rounded-xl p-4 text-center">
              <i className={`${pet.gender === 'Male' ? 'ri-men-line' : 'ri-women-line'} text-[#9B4C9A] text-xl mb-1 block`}></i>
              <p className="text-xs text-[#8B7BA8]">Gender</p>
              <p className="text-sm font-bold text-[#4A3B5C]">{pet.gender}</p>
            </div>
            <div className="bg-[#F8F6FB] rounded-xl p-4 text-center">
              <i className="ri-map-pin-line text-[#9B4C9A] text-xl mb-1 block"></i>
              <p className="text-xs text-[#8B7BA8]">Location</p>
              <p className="text-sm font-bold text-[#4A3B5C]">{pet.location}</p>
            </div>
          </div>

          <div className="mb-6">
            <h3 className="text-lg font-bold text-[#4A3B5C] mb-2">About {pet.name}</h3>
            <p className="text-sm text-[#8B7BA8] leading-relaxed">{pet.description}</p>
          </div>

          <div className="flex items-center gap-3 mb-6 p-4 bg-[#F8F6FB] rounded-xl">
            <div className="w-10 h-10 bg-gradient-to-r from-[#9B4C9A] to-[#FF9BC8] rounded-full flex items-center justify-center">
              <i className="ri-store-2-line text-white"></i>
            </div>
            <div>
              <p className="text-xs text-[#8B7BA8]">Listed by</p>
              <p className="text-sm font-bold text-[#4A3B5C]">{pet.seller}</p>
            </div>
          </div>

          <div className="flex gap-3">
            <a
              href={`mailto:info@fluffypets.com?subject=Inquiry about ${pet.name}`}
              className="flex-1 bg-gradient-to-r from-[#9B4C9A] to-[#FF9BC8] text-white py-3.5 rounded-xl font-semibold text-center hover:shadow-lg hover:scale-[1.02] transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-mail-line"></i>
              Contact Seller
            </a>
            <button
              onClick={onClose}
              className="px-6 py-3.5 border-2 border-[#E6E0F5] text-[#9B4C9A] rounded-xl font-semibold hover:bg-[#F8F6FB] transition-all whitespace-nowrap cursor-pointer"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
